import { SiteUrls } from '@tableau/shared-urls';

import { WindowLocationService } from '../../commonInfra/services/WindowLocationService';
import { getSessionManagementServiceInstance } from '../../sessionManagement/SessionManagementService';
import { IWorkbookRevision } from '../serverApi/types/IWorkbookRevision';

class PreviewWorkbookRevisionAction {


  public openPreview(revision: IWorkbookRevision) {
    const siteUrls = new SiteUrls({siteUrlName: getSessionManagementServiceInstance().sessionSiteUrlName(), queryString: window.location.search});
    WindowLocationService.open(siteUrls.workbookRevisionPreviewUrl(revision.revisionPath));
  }

}

export const PreviewWorkbookRevisionActionInstance = new PreviewWorkbookRevisionAction();
// export only the type of the class, since we don't want modules to be able to instantiate it
export type {PreviewWorkbookRevisionAction};